<svg aria-hidden="true" [ngStyle]="{'height.px': _size, 'width.px': _size}">
	<mask [attr.id]="maskId">
		<circle [attr.cx]="_size / 2" [attr.cy]="_size / 2" fill="white" [attr.r]="_size / 2"></circle>
		<circle fill="black"
			[attr.cx]="badgeRect?.left ?? 0" 
			[attr.cy]="badgeRect?.top ?? 0"
			[attr.r]="((badgeRect?.width ?? 0) / 2) + 4"></circle>
	</mask>
	<g [attr.mask]="'url(#'+ maskId +')'">
		<image x="0" y="0" height="100%" width="100%" preserveAspectRatio="xMidYMid slice"
				[attr.href]="src || 'assets/'+ (_disabled ? 'no-accounts' : 'account-circle') +'.svg'" 
				[ngStyle]="{'height.px': _size, 'width.px': _size}"></image>
	</g>
</svg>